import { alpha } from "@mui/material/styles";
import { memo } from "react";

import Stack from "@mui/material/Stack";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import ToggleButton from "@mui/material/ToggleButton";
import FormLabel from "@mui/material/FormLabel";
import Skeleton from "@mui/material/Skeleton";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import { FieldTypeSort, theme } from "@zesty-io/material";

import Tooltip from "@mui/material/Tooltip";
import InfoIcon from "@mui/icons-material/InfoOutlined";

import styles from "./WidgetListed.less";
import { useTranslation } from "react-i18next";
export const WidgetListed = memo(function WidgetListed(props) {
  const { t } = useTranslation();
  const toggleHandler = (value) => {
    if (value === null) return;
    props.dispatch({
      type: "SET_ITEM_META",
      itemZUID: props.itemZUID,
      key: "listed",
      value: value,
    });
  };
  return (
    <Card
      className={styles.WidgetListed}
      sx={{ mb: 3, backgroundColor: "transparent" }}
      elevation={0}
    >
      <CardHeader
        sx={{
          p: 0,
          backgroundColor: "transparent",
          color: alpha(theme.palette.text.primary, 0.4),
          borderBottom: 1,
          borderColor: "grey.200",
        }}
        titleTypographyProps={{
          variant: "overline",
          sx: {
            fontWeight: 400,
            color: "text.primary",
            textTransform: "uppercase",
          },
        }}
        title={t("content.itemEditParsleyBehaviorsTitle")}
      ></CardHeader>
      <CardContent
        sx={{
          p: 0,
          pt: 2,
          "&:last-child": {
            pb: 0,
          },
        }}
      >
        {props.isLoadingItem ? (
          <Stack gap={1.5}>
            <Stack direction="row" justifyContent="space-between">
              <Skeleton variant="rounded" width={192} height={20} />
              <Skeleton variant="rounded" width={60} height={20} />
            </Stack>
            <Stack gap={0.5}>
              <Skeleton variant="rounded" width={192} height={20} />

              <Skeleton variant="rounded" width="100%" height={40} />
            </Stack>
          </Stack>
        ) : (
          <>
            <FormLabel sx={{ color: "text.primary" }}>
              <Stack
                direction="row"
                alignItems="center"
                sx={{
                  mb: 1,
                }}
              >
                <Tooltip
                  title={t("content.itemEditAvailableInLoopsTooltip")}
                  arrow
                  placement="top-start"
                >
                  <InfoIcon fontSize="small" />
                </Tooltip>
                &nbsp;{t("content.itemEditAvailableInLoops")}
              </Stack>
            </FormLabel>
            <ToggleButtonGroup
              color="primary"
              size="small"
              value={props.listed}
              exclusive
              onChange={(evt, value) => toggleHandler(value)}
              sx={{ mb: 1 }}
            >
              <ToggleButton value={false}>{t("common.no")} </ToggleButton>
              <ToggleButton value={true}>{t("common.yes")} </ToggleButton>
            </ToggleButtonGroup>

            <FieldTypeSort
              sx={{ maxWidth: "200px" }}
              name="sort"
              label={
                <span
                  style={{
                    color: theme.palette.text.primary,
                    marginBottom: "8px",
                  }}
                >
                  <Tooltip
                    title={t("content.itemEditAutomatedNavigationOrderTooltip")}
                    arrow
                    placement="top-start"
                  >
                    <InfoIcon fontSize="small" />
                  </Tooltip>
                  &nbsp;{t("content.itemEditAutomatedNavigationOrder")}
                </span>
              }
              value={props.sort ? props.sort.toString() : "0"}
              onChange={(evt) => {
                props.dispatch({
                  type: "SET_ITEM_META",
                  itemZUID: props.itemZUID,
                  key: "sort",
                  value: parseInt(evt.target.value),
                });
              }}
            />
          </>
        )}
      </CardContent>
    </Card>
  );
});
